/**
 * Property Type Utilities
 * Centralized utilities for property type validation and checking
 */

export const PropertyTypeIds = {
  SINGLEFAMILYTYPE: 126,
  LANDTYPE: 115,
  COMMERCIALTYPE: 127,
  UNKNOWNTYPE: 1000,
} as const;

/**
 * Check if property type is not a building (e.g., Land, Unknown)
 * Buildings require bedrooms, bathrooms, square feet, and year built
 * @param propertyType - The property type ID to check
 * @returns true if property type is not a building (Land or Unknown)
 */
export const isNotBuildingType = (propertyType: number): boolean => {
  return propertyType === PropertyTypeIds.LANDTYPE || propertyType === PropertyTypeIds.UNKNOWNTYPE;
};
